import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";

const CollectCash = () => {
    const [loading, setLoading] = useState(false);
    const [latitude, setLatitude] = useState("");
    const [longitude, setLongitude] = useState("");
    const [amount, setAmount] = useState("");

    // Function to get the user's latitude and longitude
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    alert("Failed to get location. Please check your location settings.");
                }
            );
        } else {
            alert("Geolocation is not supported by this browser.");
        }
    }, []);

    // Function to call the API before redirecting
    const handleCollectCash = async () => {
        if (!amount) {
            alert("Please enter the amount");
            return;
        }

        setLoading(true);
        try {
            const token = sessionStorage.getItem("jwtToken");
            const response = await fetch("https://api.ipaisa.co.in/myapp/auth/cms/cmsLoginPayload", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ latitude, longitude, amount }),
            });

            const data = await response.json();
            console.log("API Response:", data);

            if (data.statusCode === "OK") {
                // Hold for 2 seconds before redirecting
                setTimeout(() => handleRedirect(data.body.payload), 2000);
            } else {
                alert("API Error: " + data.message);
            }
        } catch (error) {
            console.error("Error calling API:", error);
        } finally {
            setLoading(false);
        }
    };

    // Function to encrypt data and redirect
    const handleRedirect = (payload) => {
        const requestData = {
            additionalParams: payload.additionalParams,
            latitude: payload.latitude,
            loginType: payload.loginType,
            longitude: payload.longitude,
            supermerchantId: payload.supermerchantId,
            merchantId: payload.merchantId,
            merchantPin: payload.merchantPin,
            mobileNumber: payload.mobileNumber,
            amount: payload.amount,
            superMerchantSkey: payload.superMerchantSkey,
        };

        let parsedBase64Key = CryptoJS.enc.Base64.parse(requestData.superMerchantSkey);
        let encryptedData = CryptoJS.AES.encrypt(
            JSON.stringify(requestData),
            parsedBase64Key,
            { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 }
        ).toString();

        let encryptInfo = btoa(encryptedData);
        let redirectUrl = `https://fpuat.tapits.in/UberCMSBC/#/login?data=${encodeURIComponent(encryptInfo)}&skey=${requestData.superMerchantSkey}`;

        window.location.href = redirectUrl;
    };

    return (
        <div style={{ textAlign: "center", marginTop: "100px" }}>
            <h2>Uber CMS Web URL Integration</h2>
            <p>Click the button below to proceed with the Fingpay authentication.</p>
            <input
                type="text"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter Amount"
                style={{ marginBottom: "10px", padding: "8px", width: "200px" }}
            />
            <br />
            <input
                type="text"
                value={latitude}
                disabled
                placeholder="Latitude"
                style={{ marginBottom: "10px", padding: "8px", width: "200px", backgroundColor: "#f0f0f0" }}
            />
            <br />
            <input
                type="text"
                value={longitude}
                disabled
                placeholder="Longitude"
                style={{ marginBottom: "10px", padding: "8px", width: "200px", backgroundColor: "#f0f0f0" }}
            />
            <br />
            <button
                onClick={handleCollectCash}
                style={{
                    padding: "10px 20px",
                    fontSize: "16px",
                    backgroundColor: "#007BFF",
                    color: "white",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                }}
                disabled={loading}
            >
                {loading ? "Processing..." : "Collect Cash"}
            </button>
        </div>
    );
};

export default CollectCash;
